import { Extension } from '@tiptap/core'
import { Plugin } from 'prosemirror-state'
import { Slice, Node as ProseMirrorNode } from 'prosemirror-model'

export const CustomClipboard = Extension.create({
    name: 'customClipboard',

    addProseMirrorPlugins() {
        return [
            new Plugin({
                props: {
                    handleDOMEvents: {
                        copy: (view, event: ClipboardEvent) => {
                            const { state } = view
                            const { selection } = state

                            if (selection.empty) return false

                            const slice: Slice = selection.content()
                            const lines: string[] = []

                            // 遍历顶层 nodes
                            slice.content.forEach((node: ProseMirrorNode) => {
                                // 如果是列表（有多个 listItem）
                                if (node.type.name === 'bulletList' || node.type.name === 'orderedList') {
                                    node.content.forEach((liNode: ProseMirrorNode) => {
                                        const lineParts: string[] = []

                                        liNode.content.forEach((childNode: ProseMirrorNode) => {
                                            if (childNode.type.name === 'paragraph') {
                                                childNode.content.forEach((textNode: ProseMirrorNode) => {
                                                    if (textNode.type.name === 'text') {
                                                        lineParts.push(textNode.text || '')
                                                    } else if (textNode.type.name === 'hardBreak') {
                                                        lineParts.push('\n') // hardBreak 变成行内换行
                                                    }
                                                })
                                            }
                                        })

                                        lines.push(lineParts.join('')) // 一整个 listItem 是一行（含 hardBreak）
                                    })
                                }

                                // 单个 listItem（非列表包裹）
                                else if (node.type.name === 'listItem') {
                                    const lineParts: string[] = []

                                    node.content.forEach((childNode: ProseMirrorNode) => {
                                        if (childNode.type.name === 'paragraph') {
                                            childNode.content.forEach((textNode: ProseMirrorNode) => {
                                                if (textNode.type.name === 'text') {
                                                    lineParts.push(textNode.text || '')
                                                } else if (textNode.type.name === 'hardBreak') {
                                                    lineParts.push('\n')
                                                }
                                            })
                                        }
                                    })

                                    lines.push(lineParts.join(''))
                                }

                                // 普通段落等
                                else {
                                    lines.push(node.textContent)
                                }
                            })

                            const finalText = lines.join('\n') // 每个 listItem 一行
                            event.preventDefault()
                            event.clipboardData?.setData('text/plain', finalText)
                            return true
                        },
                    },
                },
            }),
        ]
    },
})


